import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import Image from 'next/image';

import { Gray_Light_Black, Gray_Light_White, Typography } from '@common/styles';

import { useEpickStylistItemCard } from '../services/useEpickStylistItemCard';

interface Props {
  isApp: boolean;
  src: string;
  text: string;
  onClickItemCard: () => void;
  onImpressionItemCard: () => void;
}

export const EpickStylistItemCard: React.FC<React.PropsWithChildren<Props>> = ({ isApp, src, text, onClickItemCard, onImpressionItemCard }) => {
  const {
    impression_target_ref,
    img_placeholder_ref,
    is_display_image,
    placeholder_display_style,
    myLoader,
    handleError,
  } = useEpickStylistItemCard({
    onImpressionItemCard,
  });

  return (
    <Wrap ref={impression_target_ref} onClick={onClickItemCard} is_limit_size={!isApp}>
      {is_display_image && (
        <StyledImage
          loader={myLoader}
          src={src}
          layout='fill'
          objectFit='cover'
          onError={handleError}
          alt='상품 카드 이미지'
          sizes={'43vw'}
          zeroBorderRadius
        />
      )}
      <ImagePlaceHolder
        ref={img_placeholder_ref}
        style={{ display: placeholder_display_style }}
        is_limit_size={!isApp}
        zeroBorderRadius
      />
      <Dimmed zeroBorderRadius />
      <HalfDimmed zeroBorderRadius />
      <Text className={Typography.BODY_13_SEMIBOLD}>@{text}</Text>
    </Wrap>
  );
};

const Wrap = styled.div<{ is_limit_size?: boolean }>`
  position: relative;
  min-width: 43vw;
  height: calc(43vw * 1.25);
  ${({ is_limit_size }) => is_limit_size && 'min-width: 150px; max-height: 187.5px;'};
`;

const StyledImage = styled(Image)<{ zeroBorderRadius: boolean }>`
  position: relative;
  ${({ zeroBorderRadius }) => !zeroBorderRadius && 'border-radius: 8px;'}

  &.error {
    display: none;
  }
`;

const ImagePlaceHolder = styled.div<{ is_limit_size?: boolean; zeroBorderRadius: boolean }>`
  width: 43vw;
  height: calc(43vw * 1.25);
  ${({ is_limit_size }) => is_limit_size && 'max-width: 150px; max-height: 187.5px;'};
  background-color: ${vars.v3Color.gray100};
  ${({ zeroBorderRadius }) => !zeroBorderRadius && 'border-radius: 8px;'}

  &.show {
    display: block !important;
  }
`;

const Dimmed = styled.div<{ zeroBorderRadius: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${Gray_Light_Black};
  opacity: 0.06;
  ${({ zeroBorderRadius }) => !zeroBorderRadius && 'border-radius: 8px;'}
`;

const HalfDimmed = styled.div<{ zeroBorderRadius: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
  ${({ zeroBorderRadius }) => !zeroBorderRadius && 'border-radius: 8px;'}
`;

const Text = styled.p`
  position: absolute;
  left: 16px;
  bottom: 16px;
  width: calc(100% - 32px);
  color: ${Gray_Light_White};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
